package com.wintermar.inspection.feature.util.answer_type

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.graphql.type.InspectionAnswerType
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_calendar
import inspection.composeapp.generated.resources.ic_location
import inspection.composeapp.generated.resources.ic_question
import inspection.composeapp.generated.resources.ic_text

@Composable
fun InspectionAnswerType.toVariant(): AnswerTypeContentModel {
    val themeColor = LocalAppTheme.current.color

    val content = when (this) {
        InspectionAnswerType.FREE_TEXT -> AnswerTypeContentModel(
            iconColor = themeColor.surface.accent.blue.medium.default,
            icon = Res.drawable.ic_text,
            label = "Free Text"
        )

        InspectionAnswerType.ADDRESS -> AnswerTypeContentModel(
            iconColor = themeColor.surface.accent.purple.medium.default,
            icon = Res.drawable.ic_location,
            label = "Location"
        )

        InspectionAnswerType.YES_NO_NA -> AnswerTypeContentModel(
            iconColor = themeColor.surface.accent.green.medium.hover,
            icon = Res.drawable.ic_question,
            label = "Yes/No/NA"
        )

        InspectionAnswerType.VESSEL_ID -> AnswerTypeContentModel(
            iconColor = themeColor.surface.accent.blue.medium.default,
            icon = Res.drawable.ic_text,
            label = "Free Text"
        )

        InspectionAnswerType.CALENDAR -> AnswerTypeContentModel(
            iconColor = themeColor.surface.accent.orange.medium.hover,
            icon = Res.drawable.ic_calendar,
            label = "Date and Time"
        )

        InspectionAnswerType.COMPLIANCE_NON_COMPLIANCE_NA -> AnswerTypeContentModel(
            iconColor = themeColor.surface.accent.green.medium.hover,
            icon = Res.drawable.ic_question,
            label = "Compliant/Non-Compliant/NA"
        )

        InspectionAnswerType.USER_ID -> AnswerTypeContentModel(
            iconColor = themeColor.surface.accent.blue.medium.default,
            icon = Res.drawable.ic_text,
            label = "Free Text"
        )

        else -> AnswerTypeContentModel(
            iconColor = themeColor.icon.default,
            icon = Res.drawable.ic_text,
            label = "Free Text"
        )
    }

    return remember(this, themeColor) {
        content
    }
}
